import './serviceItem.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import Zoom from 'react-reveal/Zoom';

import React from 'react';


function ServiceItem(props) {
    return (
      <Zoom>
        <div className="service--item--container">
            <div className="service--title">
                {props.title}
            </div>
                <div className="service--icon">
                    <FontAwesomeIcon icon={props.icon} />
                </div>
                <div className="service--description">
                    {props.description}
                </div>
        </div>
      </Zoom>
    );
  }

export default ServiceItem;